import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { com } from '@eidu/form'
import EntityFieldDisplayGroup from '../shared/EntityFieldDisplayGroup'
import PageLayout from '../shared/PageLayout'
import { KindViewPageProps } from '../KindPages'
import useHasPermission from '../../../permission/useHasPermission'
import EntityAction = com.eidu.sharedlib.entity.permission.EntityAction

const DefaultViewPage = ({ entity, entityType, fields }: KindViewPageProps) => {
  const navigate = useNavigate()
  const navigateToEdit = () => {
    navigate(`/entities/${entityType.id.toString()}/edit/${entity.entity.id.toString()}`)
  }

  const { hasPermission: hasUpdatePermission } = useHasPermission(entity.entity.id, EntityAction.UpdateEntity)

  return (
    <PageLayout
      title={entity.primaryLabelText}
      subtitle={entityType.name}
      actions={hasUpdatePermission ? <Button onClick={navigateToEdit}>Edit</Button> : undefined}
      showBack
    >
      <EntityFieldDisplayGroup entityType={entityType} fields={fields} />
    </PageLayout>
  )
}

export default DefaultViewPage
